import React from 'react';
import { CompoundInterestTaxExemptionToggle } from '../tax-exemption-toggle/compound-interest-tax-exemption-toggle';
import { CompoundInterestTaxRateSwitcher } from '../tax-rate-switcher/compound-interest-tax-rate-switcher';
import { CompoundInterestCurrencySwitcher } from '../currency-switcher/compound-interest-currency-switcher';

export const CompoundInterestToolbar: React.FC = () => {
    return (
        <div className="flex flex-col items-stretch overflow-hidden rounded-[2.8rem] border border-[#d9cdc5] bg-[#fdf7f2]/70 xl:flex-row xl:rounded-t-none xl:rounded-b-[4rem] xl:border-t-0">
            <div className="flex min-w-0 flex-auto items-center px-[2.4rem] py-[1.8rem] xl:pt-[5.8rem]">
                <CompoundInterestTaxExemptionToggle />
            </div>

            <div className="h-px w-full shrink-0 self-stretch bg-[#d9cdc5] xl:h-auto xl:w-px" />

            <div className="flex min-w-0 flex-auto items-center px-[2.4rem] py-[1.8rem] xl:pt-[5.8rem]">
                <CompoundInterestTaxRateSwitcher />
            </div>

            <div className="h-px w-full shrink-0 self-stretch bg-[#d9cdc5] xl:h-auto xl:w-px" />

            <div className="flex min-w-0 flex-auto items-center px-[2.4rem] py-[1.8rem] xl:pt-[5.8rem]">
                <CompoundInterestCurrencySwitcher />
            </div>
        </div>
    );
};
